import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { pluralize } from 'utils/pluralize';

export default function TableLoadedFooter({ count, singular, colSpan }) {
  if (!count) return null;

  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center" sx={{ py: 1.5, border: 0 }}>
        <Typography variant="caption" color="text.secondary">
          All {count} {pluralize(count, singular)} loaded
        </Typography>
      </TableCell>
    </TableRow>
  );
}

TableLoadedFooter.propTypes = {
  count: PropTypes.number.isRequired,
  singular: PropTypes.string.isRequired,
  colSpan: PropTypes.number.isRequired
};
